import React from 'react';

import { SingePathIcon } from './SinglePathIcon';

export const Sort = () => (
    <SingePathIcon path="M5.5437 0H0.456301C0.0505942 0 -0.152586 0.709973 0.134293 1.1252L2.67799 4.80695C2.85583 5.06435 3.14417 5.06435 3.32201 4.80695L5.86571 1.1252C6.15259 0.709974 5.94941 0 5.5437 0Z" />
);

Sort.viewBox = `0 0 6 5`;
